"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Article = _interopRequireDefault(require("../../Article"));
var _Title = _interopRequireDefault(require("../../Title"));
var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var TabPane = _FlexTabContainer["default"].TabPane;
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    flexTitle = props.flexTitle,
    style = props.style,
    source = props.source,
    imageSrc = props.imageSrc,
    _a = props.configuration,
    configuration = _a === void 0 ? [] : _a,
    className = props.className,
    onClick = props.onClick,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "flexTitle", "style", "source", "imageSrc", "configuration", "className", "onClick"]);
  // const line5 = configuration && configuration.length > 4;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-quickstarts-tab-default-class-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-quickstarts-default-class-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    styles: {
      paddingBottom: '24px'
    },
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '24px 24px 0'
    },
    className: 'quickstarts-pc'
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], __assign({
    ref: ref
  }, restProps), configuration ? configuration.map(function (item, i) {
    var _a = item,
      title = _a.title,
      key = _a.key,
      list = _a.list;
    var compatibleArr = list;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: title
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('', {
        noTab: (configuration === null || configuration === void 0 ? void 0 : configuration.length) <= 1
      }),
      key: i,
      style: key != 1 ? {
        display: 'none',
        paddingTop: '34px'
      } : {
        paddingTop: '34px'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-quickstarts-default-class'
    }, compatibleArr.map(function (items, index) {
      var _a = items || {},
        content = _a.content,
        href = _a.href,
        hrefText = _a.hrefText,
        title = _a.title,
        contentSvg = _a.contentSvg,
        contentSvgText = _a.contentSvgText,
        contentSvgImg = _a.contentSvgImg;
      var svgContent = contentSvg ? content + contentSvg : content;
      // const line5 = compatibleArr && compatibleArr.length > 4
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('flex-quickstarts-list', {
          // 'flex-quickstarts-list--5': line5,
        }),
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-quickstarts-list-inside'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-serial-container'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-number-serial'
      }, "0", index + 1), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-image-serial'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('flex-image-serial-content', {
          'flex-image-serial-content-attach': compatibleArr.length === index + 1
        })
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-quickstarts-containers'
      }, /*#__PURE__*/_react["default"].createElement(_Article["default"], {
        href: href,
        hrefText: hrefText,
        title: title,
        article: svgContent,
        contentSvg: contentSvg,
        contentSvgText: contentSvgText,
        contentSvgImg: contentSvgImg
      }))));
    }))));
  }) : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'quickstarts-mobile'
  }, configuration ? configuration.map(function (item) {
    var _a = item,
      title = _a.title,
      list = _a.list;
    var compatibleArr = list;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h2", {
      className: 'quickstarts-mobile-item-title'
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-quickstarts-default-class'
    }, compatibleArr.map(function (items, index) {
      var _a = items || {},
        content = _a.content,
        href = _a.href,
        hrefText = _a.hrefText,
        title = _a.title,
        contentSvg = _a.contentSvg,
        contentSvgText = _a.contentSvgText,
        contentSvgImg = _a.contentSvgImg;
      var svgContent = contentSvg ? content + contentSvg : content;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('flex-quickstarts-list', {}),
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-quickstarts-list-inside'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-serial-container'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-number-serial'
      }, "0", index + 1), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-image-serial'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('flex-image-serial-content', {
          'flex-image-serial-content-attach': compatibleArr.length === index + 1
        })
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-quickstarts-containers'
      }, /*#__PURE__*/_react["default"].createElement(_Article["default"], {
        href: href,
        hrefText: hrefText,
        title: title,
        article: svgContent,
        contentSvg: contentSvg,
        contentSvgText: contentSvgText,
        contentSvgImg: contentSvgImg
      }))));
    })));
  }) : null)));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = exports["default"] = Thumbnail;